<template>
  <div>
    <table class="processing-rating-chart__table">
      <thead>
        <tr>
          <th/>
          <th
            v-for="(column, did) in data"
            :key="did"
          >
            {{ column.label }}
          </th>
        </tr>
      </thead>

      <tbody>
        <tr
          v-for="(row, xlid) in xLabels"
          :key="xlid"
        >
          <th>
            {{ row }}
          </th>
          <td
            v-for="(column, did) in data"
            :key="did"
          >
            {{ column.points[xlid] }}
          </td>
        </tr>
      </tbody>

    </table>

    <c-card class="processing-rating-chart__diagram">
      <c-chart
        :data="data"
        :x-labels="xLabels"
        :x-unit="xUnit"
        :y-labels="yLabels"
        :y-unit="yUnit"
        :scroll="xLabels.length > 7"
      />
    </c-card>

  </div>
</template>

<script>
import CCard from '@/components/CCard'
import CChart from '@/components/CChart'

export default {
  name: 'CProcessRating',

  components: {
    CCard,
    CChart
  },

  props: {
    process: {
      type: Object,
      required: false
    },
    ratings: {
      type: Object,
      required: true
    },

    xLabels: {
      type: Array
    },

    yLabels: {
      type: Array
    },

    xUnit: {
      type: String,
      default: 'Bewertung nach Monat'
    },

    yUnit: {
      type: String,
      default: 'Sterne'
    },

    colors: {
      type: Object
    }
  },

  computed: {
    data () {
      let result = []

      if (this.$is(['applicant', 'css_supervisor'])) {
        this.addResults('user', this.userName, result)
      } else if (this.$is(['professor', 'css_supervisor'])) {
        this.addResults('reviewer', this.reviewerName, result)
      }

      return result
    },
    userName () {
      if (this.process) {
        return this.process.user.first_name + ' ' + this.process.user.last_name
      } else {
        return 'Studierender'
      }
    },
    reviewerName () {
      if (this.process) {
        return this.process.reviewer.first_name + ' ' + this.process.reviewer.last_name
      } else {
        return 'Betreuer'
      }
    }
  },

  methods: {
    addResults (role, label, result) {
      if (this.ratings.hasOwnProperty(role)) {
        if (this.ratings[role].length === 0) {
          return
        }

        let points = []
        for (let key in this.ratings[role]) {
          if (this.ratings[role][key]['rating'] === false) {
            points.push(1)
          } else {
            points.push(parseInt(this.ratings[role][key]['rating'].value))
          }
        }

        result.push({
          label: label,
          points: points,
          color: this.colors.hasOwnProperty(role) ? this.colors[role] : '#000'
        })
      }
    }
  }
}
</script>

<style scoped>
.processing-rating-chart__diagram {
  display: none;
}

@media (min-width: 700px) {
  .processing-rating-chart__table {
    display: none;
  }

  .processing-rating-chart__diagram {
    display: block;
    overflow-x: scroll;
  }
}
</style>
